/* eslint-disable react/jsx-key, react-native/no-inline-styles */

import React from "react"

import { AutoImage, Button, Card, Icon } from "../../../components"
import { colors, spacing } from "../../../theme"
import { DemoDivider } from "../DemoDivider"
import { Demo } from "../DemoShowroomScreen"
import { DemoUseCase } from "../DemoUseCase"
export const DemoCard: Demo = {
  name: "Card",
  description:
    "Cards are useful for displaying related information in a contained way. If a ListItem displays content horizontally, a Card can be used to display content vertically.",
  data: [
    <DemoUseCase
      description="There are a few presets that are preconfigured."
      name="Presets"
    >
      <Card
        content="Incididunt magna ut aliquip consectetur mollit dolor."
        footer="Consectetur nulla non aliquip velit."
        heading="Default Preset (default)"
      />
      <DemoDivider />
      <Card
        content="Reprehenderit occaecat proident amet id laboris."
        footer="Consectetur tempor ea non labore anim ."
        heading="Reversed Preset"
        preset="reversed"
      />
    </DemoUseCase>,

    <DemoUseCase
      description="Depending on what's required, the card comes preconfigured with different alignment strategies."
      name="Vertical Alignment"
    >
      <Card
        content="All content is automatically aligned to the top."
        footer="Even the footer"
        heading="Top (default)"
        style={{ minHeight: 160 }}
      />
      <DemoDivider />
      <Card
        content="Content is centered relative to the card's height."
        footer="Me too!"
        heading="Center"
        preset="reversed"
        style={{ minHeight: 160 }}
        verticalAlignment="center"
      />
      <DemoDivider />
      <Card
        content="All content is spaced out evenly."
        footer="I am where I want to be."
        heading="Space Between"
        style={{ minHeight: 160 }}
        verticalAlignment="space-between"
      />
      <DemoDivider />
      <Card
        content="This pushes the footer where it belongs."
        footer="I'm so lonely down here."
        heading="Force Footer Bottom"
        preset="reversed"
        style={{ minHeight: 160 }}
        verticalAlignment="force-footer-bottom"
      />
    </DemoUseCase>,

    <DemoUseCase
      description="There are a few different ways to pass content."
      name="Passing Content"
    >
      <Card
        content="Via `content` Prop"
        footer="Via `footer` Prop"
        heading="Via `heading` Prop"
      />
      <DemoDivider />
      <Card
        contentTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        contentTxOptions={{ prop: "content" }}
        footerTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        footerTxOptions={{ prop: "footer" }}
        headingTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        headingTxOptions={{ prop: "heading" }}
        preset="reversed"
      />
    </DemoUseCase>,

    <DemoUseCase
      description="Any of the preconfigured components can be replaced with your own. You can also add additional ones."
      name="Custom Components"
    >
      <Card
        ContentComponent={
          <Button
            style={{ marginVertical: spacing.sm }}
            text="ContentComponent"
            LeftAccessory={(props) => (
              <Icon
                icon="ladybug"
                style={props.style}
              />
            )}
          />
        }
        FooterComponent={
          <Button
            preset="reversed"
            text="FooterComponent"
            LeftAccessory={(props) => (
              <Icon
                icon="ladybug"
                style={props.style}
              />
            )}
          />
        }
        HeadingComponent={
          <Button
            preset="reversed"
            text="HeadingComponent"
            LeftAccessory={(props) => (
              <Icon
                icon="ladybug"
                style={props.style}
              />
            )}
          />
        }
      />
      <DemoDivider />
      <Card
        heading="RightComponent"
        verticalAlignment="center"
        RightComponent={
          <AutoImage
            maxHeight={60}
            maxWidth={80}
            style={{ alignSelf: "center" }}
            source={{
              uri: "https://user-images.githubusercontent.com/1775841/184508739-f90d0ce5-7219-42fd-a91f-3382d016eae0.png",
            }}
          />
        }
      />
      <DemoDivider />
      <Card
        heading="LeftComponent"
        preset="reversed"
        verticalAlignment="center"
        LeftComponent={
          <AutoImage
            maxHeight={60}
            maxWidth={80}
            style={{ alignSelf: "center" }}
            source={{
              uri: "https://user-images.githubusercontent.com/1775841/184508739-f90d0ce5-7219-42fd-a91f-3382d016eae0.png",
            }}
          />
        }
      />
    </DemoUseCase>,

    <DemoUseCase
      description="The component can be styled easily."
      name="Styling"
    >
      <Card
        content="Style the Content"
        contentStyle={{ backgroundColor: colors.error, color: colors.palette.neutral100 }}
        footer="Style the Footer"
        heading="Style the Heading"
        headingStyle={{ color: colors.error }}
        footerStyle={{
          textDecorationLine: "underline line-through",
          textDecorationStyle: "dashed",
          color: colors.error,
          textDecorationColor: colors.error,
        }}
        style={{
          shadowRadius: 5,
          shadowColor: colors.error,
          shadowOpacity: 0.5,
        }}
      />
    </DemoUseCase>,
  ],
}

// @demo remove-file
